import styled from '@emotion/styled'
import { WebLink } from '@news-mono/web-common'
import { breakpoint, calcRem } from '../../__styling'
import { Promotion } from './PromoCard'

type PromoCardStyleProps = {
    promotion: Promotion
}

const promosWithCommonStyles: Promotion[] = [
    'retire-ready',
    'sports-masterclass',
]

export const StyledPromoCard = styled.div<PromoCardStyleProps>(
    ({ promotion }) => [
        // Styles for all promo cards
        {
            display: 'block',
            alignSelf: 'center',
        },
        // Up Late styles
        promotion === 'up-late' && {
            height: 'auto',
            padding: calcRem(8),
            marginTop: calcRem(28),
            display: 'none',

            [breakpoint('md')]: {
                display: 'block',
            },

            img: {
                height: 'auto',
                width: '298px',
            },
        },
        // Common styles across some, but not all promotions
        promosWithCommonStyles.includes(promotion) && {
            minHeight: 170,
            position: 'relative',
            paddingBottom: '1.5rem',

            [breakpoint('xxs')]: {
                minHeight: 130,
            },

            [breakpoint('xs')]: {
                minHeight: 'auto',
            },

            [breakpoint('md')]: {
                display: 'block',
                height: '100%',
            },

            img: {
                maxWidth: '100%',
                height: '100%',
            },
        },
    ],
)

export const StyledPromoLink = styled(WebLink)({
    display: 'block',
})

export const StyledPromoImg = styled.img({
    display: 'block',
    width: 'auto',
    height: 270,
})
